export const ADDED_FROM_OUTSTANDINGS = "Añadido desde destacado";
